import { IDBConfig, IDBUtil } from '../idbUtil';
interface IStorageConfig {
    storeName: string;
}
export abstract class BaseStorage<T> {
    static idbUtil: IDBUtil<any>;
    constructor() {
        BaseStorage.idbUtil = new IDBUtil(this._getDbConfig());
    }
    get storeName() {
        return this.getStorageConfig().storeName;
    }
    protected abstract getStorageConfig(): IStorageConfig;
    private _getDbConfig(): IDBConfig {
        return {
            dbName: 'RCX_Adapter',
            version: 4,
            storeNames: ['call_ticket_link', 'chat_crm_link'],
        };
    }

    async save(id: string, data: T):Promise<T> {
        return BaseStorage.idbUtil.put(this.storeName, id, data);
    }
    async update(id: string, data: Partial<T>):Promise<T> {
        return BaseStorage.idbUtil.update(this.storeName, id, data);
    }
    async remove(id: string) {
        await BaseStorage.idbUtil.remove(this.storeName, id);
    }
    async get(id: string):Promise<T> {
        return await BaseStorage.idbUtil.get(this.storeName, id);
    }
    async getByIds(ids: string[]): Promise<Record<string, T>> {
        return await BaseStorage.idbUtil.getByKeys(this.storeName, ids);
    }
    async clear() {
        await BaseStorage.idbUtil.clear(this.storeName);
    }
}
